import { Box, Spinner } from 'theme-ui';

export function LoadingBox() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
      <Spinner />
    </Box>
  );
}
